import EventEmitter from "eventemitter3";

export class GameEvents {
  private static _emitter: EventEmitter;

  // Get the singleton instance
  public static get emitter(): EventEmitter {
    if (!this._emitter) {
      this._emitter = new EventEmitter();
    }
    return this._emitter;
  }
}